import { render } from "./InputCheckboxOptions.vue?vue&type=template&id=352f4906&scoped=true&ts=true"
import script from "./InputCheckboxOptions.vue?vue&type=script&lang=ts"
export * from "./InputCheckboxOptions.vue?vue&type=script&lang=ts"

import "./InputCheckboxOptions.vue?vue&type=style&index=0&id=352f4906&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352f4906"]])

export default __exports__